import { Services } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import entity from '@/components/entity'
import { fields } from '@/components/services/url-shortener-tracking/form'

function renderEntity(h) {
  return h(
    entity,
    {
      props: {
        value: this.rows,
        service: Services['url-shortener-tracking'],
        fields
      }
    }
  )
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        'py-2': !this.paddless
      }
    },
    [ renderEntity.call(this, h) ]
  )
}
